module.exports = __webpack_public_path__ + "img/1585030236.69311d4d.jpg";